import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import SignUpDetailsForm from 'components/forms/Auth/SignupDetailsForm';
import { activate } from '../../../actions/userActions';

import './style.css';

const SignUpDetails = props => {
  return (
    <div className="create-account__page">
      <div className="create-account__content text-center mx-auto">
        <h3 className="create-account__title mb-4" data-qa-id="signup-details-title">
          You&#39;re in! <br /> Finish creating your account
        </h3>
        <SignUpDetailsForm
          onSubmit={values => {
            const { name, password } = values;
            props.activateUser({ name, password });
          }}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return { user: state.user };
}

export default compose(
  connect(
    mapStateToProps,
    { activateUser: activate }
  )
)(SignUpDetails);



// WEBPACK FOOTER //
// ./src/pages/Account/SingupDetails/index.js